import React, { MouseEvent } from 'react';
import cls from '../utils/classnames';
import './_styles.scss';
import { COLORED_BUTTON, COLORED_BUTTON_LABEL } from '../utils/classes';
import { Hotkey } from '../Hotkey';
import Utils from '../../../../utils/Utils';

export type Color = 'blue' | 'yellow' | 'green' | 'red';

export interface IColoredButtonProps {
    /**
     * Type of hotkey associated to device, ej: PS4 type-a is equal to L1, in STB type-a is equals to Red
     */
    color: Color;
    /**
     * Text to render to the side of the button.
     */
    children: React.ReactChild | React.ReactChild[];
    /**
     * callback to fire when click button
     */
    onClick?: (event: MouseEvent<{}>) => unknown;
    /**
     * callback to fire when mouseEnter button
     */
        onMouseEnter?: () => void;
    /**
     * to add classname to main wrapper
     */
    className?: string;
    /**
     * url image
     */
    imgSrc?: string;
    id?: string;
    onFocus?: (event: MouseEvent<{}>) => unknown;
    /**
     * set focus direction for the component
     */
    navigation?: {
        left?: string,
        right?: string,
        up?: string,
        down?: string,
    };
    classSizeHotkey?: string;
    style?: object;
    colorKey?: string;
}

const rnd = () => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
};
/**
 * Colored button.
 */
export const ColoredButton: React.FunctionComponent<IColoredButtonProps> = ({
    color,
    children,
    onClick,
    className,
    imgSrc,
    id,
    onFocus,
    navigation,
    classSizeHotkey,
    style,
    onMouseEnter,
    colorKey
}) => {
    const getTypeByColor = () => {
        switch (color) {
            case "red":
                return "type-a";
            case "yellow":
                return "type-b";
            case "green":
                return "type-c";
            case "blue":
                return "type-d";
            default:
                return "type-a";
        }
    };
    const classNames = cls(COLORED_BUTTON, className);
    const {left = undefined, right = undefined, up = undefined , down = undefined} = navigation || {};
    const navigationProps: any = {};
    if(left) {
        navigationProps['data-sn-left'] = left;
    }
    if(right) {
        navigationProps['data-sn-right'] = right;
    }
    if(up) {
        navigationProps['data-sn-up'] = up;
    }
    if(down) {
        navigationProps['data-sn-down'] = down;
    }

    const handleMouseEnter = (e: any) => {
        Utils.handleMouseEnter(e)
    }

    return (
      <a
        id={id ? id : String(`keyP-${Math.floor(10000 + Math.random() * 90000)}`)}
        className={!imgSrc ? classNames : cls(`focusable`, `${COLORED_BUTTON}-yellow-principal`, ` ${classNames}`) }
        href="javascript:void(0)"
        onClick={onClick} onFocus = {onFocus}
        alt={color}
        onMouseEnter={(e) => handleMouseEnter(e)}
        {...navigationProps}
      >
        <Hotkey type={getTypeByColor()} classSizeHotkey={classSizeHotkey} colorKey={colorKey}/>
        {imgSrc &&(<img id={imgSrc} src={imgSrc} alt={imgSrc} className={cls(`${COLORED_BUTTON}-yelow-back-a`)}/>)}
        <div className={`${cls(COLORED_BUTTON_LABEL)} button-label`} style={style}>{children}</div>
      </a>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/ColoredButton/index.tsx